import { render, staticRenderFns } from "./EducationalPoints.vue?vue&type=template&id=7fa4e583&scoped=true&"
import script from "./EducationalPoints.vue?vue&type=script&lang=js&"
export * from "./EducationalPoints.vue?vue&type=script&lang=js&"
import style0 from "./EducationalPoints.vue?vue&type=style&index=0&id=7fa4e583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa4e583",
  null
  
)

export default component.exports